export class MoteRecorderStub {
  get permissionResponseReceived(): never {
    throw new Error('Not implemented.')
  }

  get permissionStatus(): never {
    throw new Error('Not implemented.')
  }

  get flightState() {
    throw new Error('Not implemented.')
  }

  get loadingPollingLimit(): never {
    throw new Error('Not implemented.')
  }

  get streamingTranscriptData() {
    throw new Error('Not implemented.')
  }

  get chunksInFlight() {
    throw new Error('Not implemented.')
  }
}
